export function getValueFromProductPrice(productPrice: string): number {
  return Number(productPrice.replace(/[^\d.]/g, ''));
}

export function getCurrencyFromProductPrice(productPrice: string): string {
  const currency = productPrice.match(/[^\d.,\s-]/g);
  if (currency) {
    return currency.join('');
  }
  return '';
}
